module.exports = __webpack_public_path__ + "img/tv-solid.0386b479.svg";